import Vue from 'vue'

Vue.filter('padZero', val => {
  return String(val).padStart(2, '0')
})
